import axios from './index'
import prefix_ms from './prefix'

// 上报文章阅读入口
export const reportHomeEntry = (data) => {
    return axios.request({
      url: prefix_ms + `/userVisitAppRecord/report`,
      method: 'post',
      data: data,
    })
  }


//////////////////
// WEBPACK FOOTER
// ./app/api/report.js
// module id = null
// module chunks = 